export const isEmptyAuthorValue = (author: string) => {
  return author.toUpperCase() === 'N/A' || author === '-';
};
